import React from 'react';
import Header from '../Header';
import ContactUsFooter from '../ContactUs/ContactUsFooter';
import './PartialDenture.css';

const PartialDenture = () => {
    const pricing = [
        { type: "Stayplate (2 Pontics; + 500", price: "₱50,000 UP" },
        { type: "Assemble Casted Clasp", price: "₱80,000 UP" },
        { type: "Flexible Uni", price: "₱1003,000 UP" },
        { type: "Flexible Bila", price: "₱120,000 UP" },
        { type: "Goldmesh (lAdditional)",price: "₱250,000 - ₱300,000" },
        { type: "Lucitone (Add In)", price: "₱20,000 - ₱25,000" },
        { type: "One Piece Uni", price: "₱12,000" },
        { type: "One Piece Bila", price: "₱14,000" },
        { type: "Flexi combi (Bilateral)", price: "₱10,000 UP" },
        { type: "Reline (Laboratory)", price: "₱8,000" },
        { type: "Rebase (Laboratory)", price: "₱1000 - ₱1,500" },
        { type: "Chairside Reline", price: "₱10,000 UP" },
        { type: "Recementation Crown", price: "30% - 50%" },
        { type: "Night Guard (Per Piece)", price: "30% - 50%" },
    ];

    return (
        <>
        <Header/>
        <div className="partialdenture-container">
            <Header />
            <div className="partialdenture-content">
                <h1>PARTIAL DENTURE</h1>
                <p>
                Orthodontics is a dental specialty focused on aligning teeth and correcting bite issues.
                Common treatments include braces and clear aligners. 2  Orthodontic treatment can improve not 
                only the appearance of teeth but also their function, reducing the risk of dental problems like 
                cavities and gum disease. The duration of treatment varies depending on the complexity of the case. 
                </p>
                <h2>Pricing</h2>
                <table className="partialdenture-table">
                        <thead>
                            <tr>
                                <th>Type of Surgery</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pricing.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.type}</td>
                                    <td>{item.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ContactUsFooter />
        </>
    );
};

export default PartialDenture;